<!--  -->
<template>
	<div class=''>
		<breadcrumb :list="breadcrumbList"></breadcrumb>
		<div style="width: 100%;display: flex;justify-content: center;">
			<el-card class="main">
				<div class="title">运维详情</div>
				<div class="content">
					<div class="textBox">
						<div class="item">
							<div class="label">报修联系人：</div>
							<div class="value">{{ options.lianxiren }}</div>
						</div>
						<div class="item">
							<div class="label">企业联系电话：</div>
							<div class="value">{{ options.lianxidianhua }}</div>
						</div>
						<div class="item">
							<div class="label">故障描述：</div>
							<div class="value">{{ options.guzhangmiaoshu }}</div>
						</div>
						<div class="item">
							<div class="label">报修时间：</div>
							<div class="value">{{ options.baoxiushijian | formatDate }}</div>
						</div>

						<template v-if="type === '维修中' || type === '已完成' || type === '已归档'">
							<div class="item">
								<div class="label">维修人员：</div>
								<div class="value">{{ options.weixiurenyuan }}</div>
							</div>
							<div class="item">
								<div class="label">接单时间：</div>
								<div class="value">{{ options.jiedanshijian | formatDate }}</div>
							</div>
						</template>

						<template v-if="type === '已完成' || type === '已归档'">
							<div class="item">
								<div class="label">维护类型：</div>
								<div class="value">{{ options.weihuleixing }}</div>
							</div>
							<div class="item">
								<div class="label">确认人：</div>
								<div class="value">{{ options.querenren }}</div>
							</div>
							<div class="item">
								<div class="label">确认电话：</div>
								<div class="value">{{ options.querendianhua }}</div>
							</div>
							<div class="item">
								<div class="label">完成时间：</div>
								<div class="value">{{ options.wanchengshijian | formatDate }}</div>
							</div>
						</template>

						<template v-if="type === '已归档'">
							<div class="item">
								<div class="label">故障类型：</div>
								<div class="value">{{ options.guzhangleixing }}</div>
							</div>
							<div class="item">
								<div class="label">维护描述：</div>
								<div class="value">{{ options.weihumiaoshu }}</div>
							</div>
							<div class="item">
								<div class="label">归档时间：</div>
								<div class="value">{{ options.guidangshijian | formatDate }}</div>
							</div>
						</template>

						<template v-if="type === '已完成' || type === '已归档'">
							<div class="item" style="margin-bottom: 0;">
								<div class="label">评分：</div>
								<div class="value">
									<div class="item">
										<div class="label state">维修技术：</div>
										<el-rate v-model="options.weixiujishu" disabled></el-rate>
									</div>
									<div class="item">
										<div class="label state">服务态度：</div>
										<el-rate v-model="options.fuwutaidu" disabled></el-rate>
									</div>
									<div class="item" style="margin-bottom: 0;">
										<div class="label state">处理速度：</div>
										<el-rate v-model="options.chulisudu" disabled></el-rate>
									</div>
								</div>
							</div>
						</template>



					</div>
					<div class="imgBox">
						<div class="top">
							<el-image :src="src"></el-image>
						</div>
						<div class="botton">
							<template v-if="type === '已完成' || type === '已归档'">
								<div id="root" ref="qrCodeUrl"></div>
							</template>
						</div>
					</div>
				</div>

				<div class="butBox">
					<el-button class="btn" type="primary" size="default" @click="$router.go(-1)">返回</el-button>
				</div>
			</el-card>
		</div>
	</div>
</template>

<script>
//例如：import  from '';
import CryptoJS from 'crypto-js';
import { getRefinedDetails, getTypes } from '@/api/day_work';
import QRCode from 'qrcodejs2';

export default {
	//import引入的组件需要注入到对象中才能使用
	name: 'refined_details',
	components: {},
	data() {
		//这里存放数据
		return {
			breadcrumbList: [
				{ name: "运维管理", path: "refined" },
				{ name: "详情", path: "refined/refined_details" }
			],
			id: '',
			type: '',
			options: {
				lianxiren: '',
				lianxidianhua: '',
				guzhangleixing: '',
				guzhangmiaoshu: '',
				baoxiushijian: '',
				weihuleixing: '',
				weixiurenyuan: '',
				weihumiaoshu: '',
				querenren: '',
				querendianhua: '',
				wanchengshijian: '',
				weixiujishu: 0,
				fuwutaidu: 0,
				chulisudu: 0,
			},
			QRcode: {
				cwid: '',//订单编号
				code: '',//企业编码
				type: '',//维护类型
				name: '',//确认人
				phone: '',//确认人手机
			},
			base64Str: ''
		}
	},

	computed: {
		src() {
			return require(`@/assets/img/${this.type}.png`)
		}
	},
	//方法集合
	methods: {
		async info() {
			this.id = this.$route.query.id
			this.type = this.formatCwstatus(this.$route.query.type)
			console.log(this.type);
			const { data } = await getRefinedDetails(this.id)
			const options = data[0]
			console.log(options);

			if (options.cwfaultmark.includes('||')) { // 由于后端加不了字段,所以需要前端多种判断
				const cwfaultmark = options.cwfaultmark.split('||')
				cwfaultmark.forEach((item, index) => {
					console.log('item', item);
					if (index === 0) {
						this.options.guzhangmiaoshu = item
					} else if (item.includes('联系电话')) {
						this.options.lianxidianhua = item.split('：')[1]
					} else if (item.includes('联系人')) {
						this.options.lianxiren = item.split('：')[1]
					} else if (item.includes('确认电话')) {
						this.options.querendianhua = item.split('：')[1]
					} else if (item.includes('确认人')) {
						this.options.querenren = item.split('：')[1]
					}
				})
			} else { //如果没有 '||' 则是故障描述
				this.options.guzhangmiaoshu = options.cwfaultmark
			}
			this.options.baoxiushijian = options.cwdate ? options.cwdate.split('T').join(' ') : ''
			this.options.jiedanshijian = options.cwassigntime ? options.cwassigntime.split('T').join(' ') : ''
			this.options.wanchengshijian = options.cwcompletiontime ? options.cwcompletiontime.split('T').join(' ') : ''
			this.options.guidangshijian = options.cwconfirmtime ? options.cwconfirmtime.split('T').join(' ') : ''
			this.options.weixiurenyuan = options.empname
			this.options.weihumiaoshu = options.cwcorrect
			// this.QRcode.code = '3333333333'
			this.QRcode.code = this.$store.getters.basicInfo.csdm
			this.QRcode.name = this.options.querenren
			this.QRcode.phone = this.options.querendianhua
			this.QRcode.type = options.cwworktype
			this.QRcode.cwid = options.cwid
			this.options.weihuleixing = options.cwworktype ? await this.weihuleixingFilter(options.cwworktype) : ''
			this.options.guzhangleixing = options.ftname


			const pfArray = (options.cwconfirmscore + '').split('')
			if (!options.cwconfirmscore || options.cwconfirmscore.toString().length < 3) return
			this.options.weixiujishu = Number(pfArray[0])
			this.options.fuwutaidu = Number(pfArray[1])
			this.options.chulisudu = Number(pfArray[2])
			if (this.type === '已完成' || this.type === '已归档') {
				const key = CryptoJS.enc.Utf8.parse('abcdef0123456789');
				const iv = CryptoJS.enc.Utf8.parse('abcdef0123456789');
				const source = JSON.stringify(this.QRcode);

				const password = CryptoJS.enc.Utf8.parse(source);
				const encrypted = CryptoJS.AES.encrypt(password, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
				this.base64Str = encrypted.toString()
				this.creatQrCode(this.base64Str)

			}
		},

		async weihuleixingFilter(val) { //转码
			const { data } = await getTypes()
			// console.log('转码 ', data, val);
			let temp = ''
			data.forEach(item => {
				if (item.bscode == val) {
					temp = item.bsname
				}
			})
			return temp
		},
		formatCwstatus(val) {
			if (!val && val != 0) return
			let temp = ''
			switch (val) {
				case '报修':
					temp = '接单中'
					break;
				case '维护':
					temp = '维修中'
					break;
				case '派单':
					temp = '维修中'
					break;
				case '确认完成':
					temp = '已完成'
					break;
				case '完成':
					temp = '已归档'
					break;

			}
			return temp
		},

		creatQrCode(data) { //创建二维码
			console.log('二维码', data);
			this.qrcode = new QRCode(this.$refs.qrCodeUrl, {
				text: data, // 需要转换为二维码的内容
				width: 150,
				height: 150,
				colorDark: "#000000",
				colorLight: "#ffffff",
				correctLevel: QRCode.CorrectLevel.H
			});
		},
	},
	filters: {
		formatDate(val) {
			if (!val && val != 0) return
			let tempString = val
			if (tempString.includes('.')) {
				tempString = tempString.split('.')[0]
			}
			return tempString
		},
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.info()
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {

	},

}
</script>
<style lang='less' scoped>
.main {
	width: 50% !important;
}

.title {
	margin-bottom: 19px;
	font-size: 20px;
	font-weight: 500;
	color: #25282C;
}

.content {
	display: flex;
	justify-content: space-between;
}

.textBox {
	font-size: 14px;
	font-weight: 500;
	color: #25282C;

	.item {
		display: flex;
		margin-bottom: 20px;

		.label {
			width: 100px;
			text-align: right;
		}

		.value {}

		.state {
			width: 80px;
			text-align: left;
		}
	}

}

.imgBox {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.butBox {
	width: 100%;
	display: flex;
	justify-content: center;
	position: absolute;
	bottom: 20px;

	.btn {
		background-color: #6345D5;
	}
}
</style>